import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios.js'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import {Message} from 'element-ui'
import $router from '@/router'

//创建 axios 实例
const service = axios.create({
    baseURL:'/',
    timeout:60000 //请求超时时间
})

// 设置 post、put 默认 Content-Type
service.defaults.headers.post['Content-Type'] = 'application/json'
service.defaults.headers.put['Content-Type'] = 'application/json'

// 添加请求拦截器
service.interceptors.request.use(
    (config) => {
        const token = Vue.ls.get(ACCESS_TOKEN);
        if(config.method === 'post' || config.method === 'put'){
            // post、put 提交时，将对象转换为string
            config.data = JSON.stringify(config.data);
        }
        if(token){
            config.headers['Access-Token'] = token
        }
        if (config.url?.includes('/api/statistics/platformdashboard/getcommondimensionhistory') || config.url?.includes('/api/statistics/platformdashboard/getcommondimensionhistory')  ) {
            config.headers['Authorization'] = 'Bearer ' + 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vd3d3LmFzcG5ldGJvaWxlcnBsYXRlLmNvbS9pZGVudGl0eS9jbGFpbXMvdGVuYW50SWQiOm51bGwsInRlbmFudGlkIjpudWxsLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6MiwiaWQiOjIsIm5hbWUiOiJhZG1pbiIsInVzZXJuYW1lIjoiYWRtaW4iLCJwaG9uZW51bWJlciI6bnVsbCwibmJmIjoxNjgwNTY5NjQzLCJpYXQiOjE2ODA1Njk2NTMsImV4cCI6MTcwMjE2OTY1MywiaXNzIjoiTWFzdGVyIiwiYXVkIjoiTWFzdGVyIn0.6rBsfzXIG8QCILwiWGQwGXfxUvmPPYtxN9m6c8BmHXg'
        }
        //请求发送前进行处理
        return config
    },
    (error) => {
        console.log(error)
        //请求错误
        return Promise.reject(error)
    }
)

//添加响应请求拦截器
service.interceptors.response.use(
    (response) => {
        let {data} = response;
        return Promise.resolve(data)
    },
    (error) => {
        let info = {},
            {status,statusText,data} = error.response;
        if(!error.response){
            info = {
                code:5000,
                msg:'Network Error'
            }
        }else{
            info = {
                code:status,
                data:data,
                msg:statusText
            }
        }
        Message.error(info.data.msg)
        if (info.data.code == 401){
            $router.push({ path:'/login'  })
        }
        return Promise.reject(info)
    }
)

const installer = {
    vm: {},
    install (Vue) {
      Vue.use(VueAxios, service)
    }
  }
export {
    installer as VueAxios,
    service as axios
  }